import React from 'react'
import { Route, Routes, Navigate } from "react-router-dom";
import { LoginScreen } from '../components/public/pages/auth/login/LoginScreen';
import { RegisterScreen } from '../components/public/pages/auth/register/RegisterScreen';
import { Landing } from '../components/public/pages/landing/Landing';
import { VerifyEmail } from '../components/public/pages/auth/verify_email/VerifyEmail';
import { useSelector } from 'react-redux';
import { RecoveryPassword } from '../components/public/pages/auth/recovery/RecoveryPassword';
import { ResetPassword } from '../components/public/pages/auth/reset/ResetPassword';
import { ActivateAccount } from '../components/public/pages/auth/activate/ActivateAccount';

export const AuthRouter = () => {

    const { id, token  } = useSelector(state => state.auth);
    const { adminEmailVerified } = useSelector(state => state.company);

    if(!adminEmailVerified && id && token){
        return (
            <Routes>
                <Route path="/" exact element={ <Landing /> }  />
                <Route path="/auth/verify-email" exact element={ <VerifyEmail /> }  />
                <Route path="*" element={<Navigate to ="/auth/verify-email" />}/>
            </Routes>
        )
    }


    return (
        <Routes>
            <Route path="/" exact element={ <Landing /> }  />
            <Route path="/auth/login" exact element={ <LoginScreen /> }  />
            <Route path="/auth/register" exact element={ <RegisterScreen /> }  />
            <Route path="/auth/recovery" exact element={ <RecoveryPassword /> }  />
            <Route path="/reset-password" exact element={ <ResetPassword /> }  />
            <Route path="/activate-account" exact element={ <ActivateAccount /> }  />
            <Route path="*" element={<Navigate to ="/" />}/>
        </Routes>
    )
}
